import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewDocsUserListComponent } from './docuserlist/preview-docs-user-list.component';
import { PreviewDocsUserComponent } from './previewuserdocs/preview-docs-user.component';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { SharedPipesModule } from 'src/app/shared/pipes/shared-pipes.module';
import { FiltroTipoDocumentoPipe } from './pipes/filtro-tipo-documento.pipe';
import { AgrupacionNifPipe } from './pipes/agrupacion-nif.pipe';
import { IncidenciasGravesPipe } from './pipes/incidencias-graves.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    PreviewDocsUserListComponent,
    PreviewDocsUserComponent,
    FiltroTipoDocumentoPipe,
    AgrupacionNifPipe,
    IncidenciasGravesPipe
  ],
  exports: [
    PreviewDocsUserListComponent,
    PreviewDocsUserComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    SharedPipesModule
  ]
})
export class DocPreviewModule { }
